// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"MobileBreak_mobileOnly__ZJmLD"};